import React from 'react';
import { IconAI } from '../../assets/icons/IconAI';
import { PageTitle } from '../../ui/PageTitle/PageTitle';
import type { OnboardingHeaderProps } from './types';

/** Icon + title + optional subtitle banner shared by every onboarding screen. */
export const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({ title, subtitle, testId }) => (
    <div className="flex flex-col items-center text-center gap-m">
        <IconAI className="w-8 h-8" />
        <PageTitle data-testid={testId}>{title}</PageTitle>
        {subtitle && <p className="text-meta text-content-tertiary max-w-md">{subtitle}</p>}
    </div>
);
